import { NewClient } from "./client";
import store from "@/_store";
import appConfig from "@/app.config";
// const appConfig = {
//   apiURL: "https://api.solicitapp.com/wp-json/",
//   jwtPath: "jwt-auth/v1/",
//   sappPath: "sapp/v2/"
// };

const apiClient = new NewClient(appConfig.apiURL);

// console.log(client.client);

// Add a response interceptor
apiClient.client.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      // console.log("refresh");
    }
    if (error.response.status === 403) {
      // console.log("update and retry");
      // location.reload();
      // console.log(error.response.data);
      if (error.response.data.code) {
        // if (error.response.data.code == )
        switch (error.response.data.code) {
          case "jwt_auth_invalid_token":
            store.dispatch("authentication/logout");
            break;
          case "jwt_auth_bad_iss":
            store.dispatch("authentication/logout");
            break;
          default:
            break;
        }
      }
    }
    if (error.response.status >= 500) {
      // Raven.captureException(error);
    }

    return Promise.reject(error);
  }
);

export { apiClient };
